import React, { useState } from "react";
import { useContext } from "react";
import FromMonto from "../../escritorio/precalificacionesEscritorio/FromMonto";
import PreCalificacionEscritorio from "../../escritorio/precalificacionesEscritorio/PreCalificacionEscritorio";
import { clienteAxios, PersonasContext, Portal, Swal, useHistory } from "../../shared";
import { TituloTabla } from "../../shared/Estilos";
import ModalNotificacion from "../modals/ModalNotificacion";
import Modal from "../../../module/modal/Modal";
import "../../shared/styles/UnifiedTable.css";

const TablaPersonas = ({ lista, setConsultar, usuarios, usuario }) => {
  const personasContext = useContext(PersonasContext);
  const { SeleccionarPrecalificar } = personasContext;

  const history = useHistory();

  const [search, setSearch] = useState("");
  const [clienteSeleccionado, setSeleccionado] = useState(null);
  const [steps, setSteps] = useState(0);

  //Formularios
  const [form, setForm] = useState({
    body: "", //item.nombre+" "+item.apellido,
    link: "", //"/precalificar/"+item.id,
    mensaje: "",
    user_from: usuario.id,
    user_to: [],
    asunto: "",
  });

  //modal
  const [modal_notificacion, setModalNoti] = useState(false);
  const [isOpened, setOpened] = useState(false);
  const openModal = () => {
    setOpened(true);
    window.scrollTo(0, 0);
  };
  const closeModal = (cierro) => {
    if (cierro) {
      setOpened(false);
    }
    setConsultar(true);
    //setemailSeleccionado(null);
  };
  //modal

  const editar = (id) => {
    history.push("/clientes/editar/" + id);
  };

  const solicitarPrecalificacion = (id, item) => {
    localStorage.setItem("id", id);
    setSeleccionado(id)
    openModal();
    document.getElementById('btn-notificacion-analista').click();
  };

  const precalificar = (id) => {
    history.push("/precalificar/" + id);
  };

  const generarCreditoEspecial = (item) => {
    console.log(item);
    history.push("/creditos/especial/nuevo/" + item.id + "/" + null);
  }

  const calificaciones = (id) => {
    history.push("/calificaciones/" + id);
  };

  const generarCredito = (item) => {
    history.push("/creditos/nuevo/" + item.id);
  };

  const modalNoti = (item) => {
    setSeleccionado(item);
    setModalNoti(true);
  }

  const acciones = (estado) => {
    switch (estado) {
      case null:
        return (
          <>
            <option value="Solicitar Precalificacion">
              Solicitar Análisis Financiero
            </option>
            <option value="Solicitar Revision">Notificar</option>
          </>
        );

      case "Solicitada":
        if (usuario.rol === "Precalificador" || usuario.rol === "Admin") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">
                Ver Análisis Financiero
              </option>
              <option value="Solicitar Revision">Notificar</option>
            </>
          );
        } else {
          return <>
            <option value="Ver Calificaciones">
              Ver Análisis Financiero
            </option>
            <option value="Solicitar Revision">Notificar</option>
          </>
        }
        break;
      //return <option value="Ver Calificaciones">Ver Calificaciones</option>;
      case "Rechazada":
      case "Observada":
        if (usuario.rol === "Precalificador" || usuario.rol === "Admin") {
          return (
            <>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">
                Ver Análisis Financiero
              </option>
              <option value="Solicitar Revision">Notificar</option>
            </>
          );
        } else {
          return <>
            <option value="Ver Calificaciones">
              Ver Análisis Financiero
            </option>
            <option value="Solicitar Revision">Notificar</option>
          </>
        }
        break;
      case "Pendiente":
      case "Aceptada":
        if (usuario.rol === "Vendedor" || usuario.rol === "Admin") {
          return (
            <>
              <option value="Generar Credito Especial">Generar Credito Especial</option>
              <option value="Generar Credito">Generar Credito</option>
              <option value="Pre Calificar">Análizar</option>
              <option value="Ver Calificaciones">Ver Análisis Financiero</option>
              <option value="Solicitar Revision">Notificar</option>
            </>
          );
        } else {
          if (usuario.rol === "Precalificador") {
            return <>
              <option value="Generar Credito">Generar Credito</option>
              <option value="Ver Calificaciones">
                Ver Análisis Financiero
              </option>
              <option value="Solicitar Revision">Notificar</option>
            </>
          }
        }
      default:
        break;
    }
  };

  const onChange = (e, item) => {
    SeleccionarPrecalificar(item);

    switch (e.target.value) {
      case "Editar":
        editar(item.id);
        break;
      case "Generar Credito Especial": {
        generarCreditoEspecial(item)
      } break;
      case "Generar Credito":
        generarCredito(item);
        break;
      case "Ver Calificaciones":
        calificaciones(item.id);
        break;
      case "Solicitar Precalificacion":
        console.log(item);
        solicitarPrecalificacion(item.id, item);
        break;
      case "Pre Calificar":
        console.log(item);

        precalificar(item.id);
        break;
      case "Solicitar Revision":
        setSeleccionado(item);
        setModalNoti(true);
        document.getElementById('btn-notificacion-solicitar').click();
        break;
      default:
        break;
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "delete_user_to": {
        let result = form.user_to;
        delete (result[value]);


        result = result.filter((item) => {
          return item != null;
        });

        setForm({
          ...form,
          user_to: result
        })
      } break;
      case "user_to":
        {
          let result = form.user_to
          result.push(value)

          setForm({
            ...form,
            user_to: result
          })

          //Reset
          setSearch("");
        }
        break;
      case "enviar":
        {
          let dataForm = form;

          //console.log(clienteSeleccionado);

          dataForm.body = clienteSeleccionado.nombre + " " + clienteSeleccionado.apellido;
          dataForm.link = "/precalificar/" + clienteSeleccionado.id;

          try {
            await clienteAxios.post("/Notificaciones/add", dataForm);
            Swal.fire({
              icon: "success",
              title: "Notificacion enviada con exito",
              text: "",
            });

            setModalNoti(false);
          } catch (e) { }
        }
        break;
      case "close":
        {
          setModalNoti(false);
        }
        break;
    }
  };
  //Logs
  //console.log(clienteSeleccionado);
  return (
    <div className="min-vh-100">
      <label className="d-none"><button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#notificacion-analista"
        id="btn-notificacion-analista"
      ></button>
      </label>
      <label className="d-none"><button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#notificacion-solicitar"
        id="btn-notificacion-solicitar"
      ></button>
      </label>

      <div className="unified-table-container">
        <table className="unified-table">
          <thead>
            <tr>
              <th className="text-center"><div>Acciones</div></th>
              <th className="text-start"><div>Apellido y Nombre</div></th>
              <th className="text-center"><div>DNI</div></th>
              <th className="text-center"><div>Estado</div></th>
              <th className="text-center"><div>Teléfono</div></th>
              <th className="text-start"><div>Domicilio</div></th>
            </tr>
          </thead>
          <tbody>
            {lista.map((item) => (
              <tr key={item.id}>
                <td className="text-center">
                  <select
                    name="opciones"
                    className="unified-table-select"
                    onChange={(event) => onChange(event, item)}
                  >
                    <option value="">Seleccione..</option>
                    <option value="Editar">Editar</option>
                    {acciones(item.estado)}
                  </select>
                </td>
                <td className="text-start">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/clientes/ver/${item.id}`}
                    className="unified-table-link"
                  >
                    {item.apellido}, {item.nombre}
                  </a>
                </td>
                <td className="text-center">{item.nro_documento}</td>
                <td className="text-center">
                  <span className={`unified-badge ${
                    item.estado === 'Aceptada' ? 'unified-badge-success' :
                    item.estado === 'Rechazada' ? 'unified-badge-danger' :
                    item.estado === 'Observada' ? 'unified-badge-warning' :
                    item.estado === 'Juicio' ? 'unified-badge-dark' :
                    item.estado === 'Solicitada' ? 'unified-badge-info' :
                    item.estado === 'Pendiente' ? 'unified-badge-secondary' :
                    'unified-badge-light'
                  }`}>
                    {item.estado || 'Sin calificar'}
                  </span>
                </td>
                <td className="text-center">
                  {item.nro_telefono_prefix && item.nro_telefono
                    ? `${item.nro_telefono_prefix} ${item.nro_telefono}`
                    : item.nro_telefono || '-'}
                </td>
                <td className="text-start">
                  {[item.calle, item.numero, item.ciudad].filter(Boolean).join(', ') || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal
        title="Solicitar Precalificacion"
        id="notificacion-analista"
        width={"700px"}
        steps={steps}
        setSteps={setSteps}
        onClose={{
          name: "close",
          function: onClick,
        }}
        children={
          isOpened ? <FromMonto
            idpersona={1}
            closeModal={closeModal}
          /> : ""
        }
      />

      <Modal
        title="Notificacion"
        id="notificacion-solicitar"
        width={"600px"}
        steps={steps}
        setSteps={setSteps}
        onClose={{
          name: "close",
          function: onClick,
        }}
        onClick={{
          title: "ENVIAR",
          name: "enviar",
          function: onClick
        }}
        children={
          modal_notificacion && usuarios ? (
            <ModalNotificacion
              search={search}
              setSearch={setSearch}
              user={usuario}
              usuarios={usuarios}
              onClick={onClick}
              setForm={setForm}
              form={form}
            />
          ) : (
            ""
          )
        }
      />

      {
        /* 
      <Portal isOpened={isOpened} onClose={closeModal}>
        <FromMonto item={clienteSeleccionado} closeModal={closeModal} />
      </Portal>

      {modal_notificacion && usuarios ? (
        <ModalNotificacion
          user={usuario}
          search={search}
          setSearch={setSearch}
          usuarios={usuarios}
          onClick={onClick}
          onChange={onChange}
          setForm={setForm}
          form={form}
        />
      ) : (
        ""
      )}
    */
      }
    </div>
  );
};

export default TablaPersonas;
